import React from 'react';
import { Button } from 'react-bootstrap';
import linkedinIcon from '../assets/linkedin.svg';
import githubIcon from '../assets/github.svg';
import youtubeIcon from '../assets/youtube.svg';
import emailIcon from '../assets/email-icon.png';

class Socials extends React.Component {
  constructor() {
    super();
    this.state = {
      socials: [
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/in/wesam-abdel',
          pic: linkedinIcon,
        },
        {
          title: 'Github',
          link: 'https://github.com/wewesemsem',
          pic: githubIcon,
        },
        {
          title: 'YouTube',
          link: 'https://www.youtube.com/@WesamTechnologies',
          pic: youtubeIcon,
        },
        {
          title: 'Email',
          link: 'mailto:hello@wesamtechnologies.com?subject=Hello&body=Website',
          pic: emailIcon,
        },
      ],
    };
  }
  render() {
    const sizeClass = 'social-link social-link-' + this.props.size;
    const socials = this.props.hideEmail
      ? this.state.socials.filter((social) => social.title !== 'Email')
      : this.state.socials;
    return (
      <div className="socials body-link">
        {socials.map((social) => {
          return (
            <Button
              variant="outline-info"
              href={social.link}
              className="social-button"
              key={social.title}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt={social.title} src={social.pic} className={sizeClass} />
            </Button>
          );
        })}
      </div>
    );
  }
}

export default Socials;
